import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Maximize2, X } from "lucide-react";

/**
 * Wraps a chart/widget card with a fullscreen expand button
 */
export default function ExpandableCard({ title, children, className = "" }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <Card className={`p-5 rounded-2xl border shadow-sm relative group ${className}`}>
        <button
          onClick={() => setExpanded(true)}
          className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity p-1.5 rounded-lg bg-muted/80 hover:bg-muted text-muted-foreground hover:text-foreground z-10"
          title="Expand fullscreen"
        >
          <Maximize2 size={14} />
        </button>
        {children}
      </Card>

      <Dialog open={expanded} onOpenChange={setExpanded}>
        <DialogContent className="max-w-[95vw] w-[95vw] max-h-[90vh] h-[85vh] rounded-2xl p-6 overflow-auto">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold" style={{ fontFamily: 'Playfair Display' }}>{title}</h3>
            <Button variant="ghost" size="icon" onClick={() => setExpanded(false)} className="rounded-xl">
              <X size={18} />
            </Button>
          </div>
          <div className="h-[calc(100%-60px)]">
            {children}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
